import React from "react";
import { useTranslation } from "react-i18next";
import { DetailRow, InputRow, SwitchRow } from "../Rows";
import { FormCard, FormGrid } from "../FormCard";

const AccessGroupForm = ({
    accessGroup = {},
    handleInputChange,
    showGlobalAccess = false,
    showOrganizationName = false,
}) => {
    const { t } = useTranslation();
    return (
        <FormCard title={t("accessGroup.details")}>
            <FormGrid>
               
                <InputRow
                    label={t("common.name")}
                    value={accessGroup.name || ""}
                    onChange={(v) => handleInputChange("name", v)}
                    required
                />

                <InputRow
                    label={t("common.description")}
                    value={accessGroup.description || ""}
                    onChange={(v) => handleInputChange("description", v)}
                />

                {showGlobalAccess && (
                    <SwitchRow
                        label={t("form.hasGlobalSiteAccess")}
                        checked={!!accessGroup.hasUniversalSiteAccess}
                        onChange={(v) =>
                            handleInputChange("hasUniversalSiteAccess", v)
                        }
                    />
                )}
                {showOrganizationName && accessGroup.organizationName && (
                    <DetailRow
                        label={t("form.organizationName")}
                        value={accessGroup.organizationName}
                    />
                )}
            </FormGrid>
        </FormCard>
    );
};

export default AccessGroupForm;
